import { useLottie } from "lottie-react";

const useSFAnimation = ({
  animation,
  loop = false,
  autoplay = true,
  style = {},
}) => {
  const options = {
    animationData: animation,
    loop,
    autoplay,
  };

  return useLottie(options, style);
};

// const SFAnimation = ({
//   animation,
//   loop = false,
//   style = {},
//   onMouseEnter = () => {},
//   onMouseLeave = () => {},
// }) => {
//   const ref = useRef();

//   return (
//     <Lottie
//       ref={ref}
//       animationData={animation}
//       loop={loop}
//       style={style}
//     />
//   );
// };

export default useSFAnimation;
